import React from 'react';
import { IconProps } from './types';
import cx from 'classnames';
import styles from './SocialIcons.module.scss';

export const Instagram = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    className={cx(styles.base, svgProps.className)}
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9999 8.86475C11.1663 8.86475 8.86475 11.1663 8.86475 13.9999C8.86475 16.8335 11.1663 19.1407 13.9999 19.1407C16.8335 19.1407 19.1407 16.8335 19.1407 13.9999C19.1407 11.1663 16.8335 8.86475 13.9999 8.86475Z" />
    <path d="M21.7504 0H6.2496C2.8056 0 0 2.8056 0 6.2496V21.7504C0 25.2 2.8056 28 6.2496 28H21.7504C25.2 28 28 25.2 28 21.7504V6.2496C28 2.8056 25.2 0 21.7504 0ZM14 23.072C8.9992 23.072 4.928 19.0008 4.928 14C4.928 8.9992 8.9992 4.9336 14 4.9336C19.0008 4.9336 23.072 8.9992 23.072 14C23.072 19.0008 19.0008 23.072 14 23.072ZM23.2624 6.58C22.204 6.58 21.3416 5.7232 21.3416 4.6648C21.3416 3.6064 22.204 2.744 23.2624 2.744C24.3208 2.744 25.1832 3.6064 25.1832 4.6648C25.1832 5.7232 24.3208 6.58 23.2624 6.58Z" />
  </svg>
);
